import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiSharedDoc\GetWikiSharedDocListController::__invoke
* @see app/Http/Controllers/WikiSharedDoc/GetWikiSharedDocListController.php
* @route '/api/wiki-shared-docs'
*/
const GetWikiSharedDocListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiSharedDocListController.url(options),
    method: 'get',
})

GetWikiSharedDocListController.definition = {
    methods: ["get","head"],
    url: '/api/wiki-shared-docs',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiSharedDoc\GetWikiSharedDocListController::__invoke
* @see app/Http/Controllers/WikiSharedDoc/GetWikiSharedDocListController.php
* @route '/api/wiki-shared-docs'
*/
GetWikiSharedDocListController.url = (options?: RouteQueryOptions) => {
    return GetWikiSharedDocListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiSharedDoc\GetWikiSharedDocListController::__invoke
* @see app/Http/Controllers/WikiSharedDoc/GetWikiSharedDocListController.php
* @route '/api/wiki-shared-docs'
*/
GetWikiSharedDocListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiSharedDocListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiSharedDoc\GetWikiSharedDocListController::__invoke
* @see app/Http/Controllers/WikiSharedDoc/GetWikiSharedDocListController.php
* @route '/api/wiki-shared-docs'
*/
GetWikiSharedDocListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetWikiSharedDocListController.url(options),
    method: 'head',
})

export default GetWikiSharedDocListController